import { translate, type Locale, type TranslationKey } from '../i18n';
import { tools } from './tools';

export function Home({ locale }: { locale: Locale }) {
  const t = (key: TranslationKey, values?: Record<string, string | number>) => translate(locale, key, values);

  return (
    <div className="home">
      {/* <header className="home__hero">
        <h1>{t('hubTitle')}</h1>
        <p>{t('hubSubtitle')}</p>
      </header> */}

      <div className="home__grid">
        {tools.map((tool) => (
          <a key={tool.id} className="tool-card" href={`#/${tool.route}`}>
            <span className="tool-card__icon">{tool.icon}</span>
            <h2>{t(tool.nameKey)}</h2>
            <p>{t(tool.summaryKey)}</p>
            <span className="tool-card__cta">{t('openTool')} →</span>
          </a>
        ))}
      </div>
    </div>
  );
}
